import { useState, useEffect } from "react";
import { Input } from "semantic-ui-react";

export default function NumberInput({
  value,
  onChange,
  placeholder = "0",
  ...props
}) {
  const [internalValue, setInternalValue] = useState(value?.toString() ?? "");

  useEffect(() => {
    if (value !== undefined && value !== null && value.toString() !== internalValue) {
      setInternalValue(value.toString());
    }
  }, [value]);

  const handleChange = (e, { value }) => {
    setInternalValue(value);

    if (
      value === "" ||
      value === "-" ||
      value === "-." ||
      value === "."
    ) {
      return;
    }

    const parsed = Number(value);
    if (!isNaN(parsed)) {
      onChange?.({ target: { value:parsed } });
    }
  };

  return (
    <Input
      {...props}
      type="text"
      value={internalValue}
      placeholder={placeholder}
      onChange={handleChange}
    />
  );
}